module.exports = __webpack_public_path__ + "img/wow.71120f70.png";